import React from 'react';
import { Typography, Space } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

export default function NoteRulesExamples() {
  const { t } = useTranslation();
  
  // Get the translation and ensure it's an array
  const examples = t('note_rules.empty_state_examples', { returnObjects: true }) || [];

  return (
    <div data-testid="note-rules-examples">
      <Text type="secondary" style={{ display: "block", marginBottom: "8px" }}>
        {t('note_rules.empty_state_examples_title')}
      </Text>
      <Space direction="vertical" size="small" style={{ width: "100%" }} align="start">
        {examples.map((example, index) => (
          <div key={index} style={{ 
            padding: "8px 12px",
            backgroundColor: "#f5f5f5",
            borderRadius: "4px",
            border: "1px dashed #d9d9d9",
            maxWidth: "700px"
          }}>
            <Text italic style={{ color: '#595959' }}>{example}</Text>
          </div>
        ))}
      </Space>
    </div>
  );
} 